// extracted by mini-css-extract-plugin
module.exports = {"shareButton":"z-LUn","description":"r8qO6","label":"IM8Cf","periods":"+OWak","expiresNote":"EnRdI","linkRow":"Rg6wJ","linkInput":"VRr96"};